import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';



import { showLoading, hideLoading } from '../../../../store/app';
import { toastr } from '../../../../components/CustomToast';
import WebAPIClient, {
  errorResponseToastr,
} from '../../../../api/_energytracer';



export default function BenchmarkBuildings() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [resourceOption, setResourceOption] = useState('building')
  const [resourceId, setResourceId] = useState(null);

  const handleLoading = (loading) => {
    if (loading) {
      setIsLoading(true);
      dispatch(showLoading());
    } else {
      setIsLoading(false);
      dispatch(hideLoading());
    }
  };



  const handleCreateResource = async () => {
    handleLoading(true);
    let url = 'veregy_benchmarking/create_resource';
    let payload = { 'resource_type': resourceOption, 'resource_id': resourceId }

    try {
      await new WebAPIClient().POST(url, payload);
      toastr.success({
        title: 'Building(s) Created',
      });
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      handleLoading(false);
      dispatch(hideLoading());
    }
  };

  return <div>
    <h3>Create Verified Buildings</h3>
    <form>
      <List disablePadding>
        <ListItem disableGutters>
          <FormControl id='resource' variant='standard' fullWidth>
            <InputLabel id='resource-label'>Resource Option</InputLabel>
            <Select
              labelId='resource-label'
              name='resource'
              onChange={(e) => {
                setResourceOption(e.target.value);
              }}
              value={resourceOption}
              MenuProps={{
                MenuListProps: { disablePadding: true },
                slotProps: {
                  paper: { sx: { minWidth: 'unset !important' } },
                },
              }}
              sx={{
                backgroundColor: 'unset',
                '& .MuiSelect-select': {
                  display: 'flex',
                  alignItems: 'center',
                },
              }}>
              <MenuItem value=''></MenuItem>
              <MenuItem key={'building'} value={'building'}>
                Single Building
              </MenuItem>
              <MenuItem key={'organization_buildings'} value={'organization_buildings'}>
                All Org Buildings
              </MenuItem>
            </Select>
          </FormControl>
        </ListItem>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={resourceOption === 'building' ? `Building ID` : `Organization ID`}
            value={resourceId ? resourceId : ''}
            onChange={(e) => setResourceId(e.target.value)}
          />
        </ListItem>


        <Button
          type='submit'
          onClick={handleCreateResource}
          color='primary'
          variant='contained'
          disabled={
            !resourceId ||
            isLoading
          }>
          Submit
        </Button>
      </List>
    </form>
  </div>
}